import { useCallback } from 'react'
import {
  getPatientValueRevenueReport,
  type PatientValueRevenueReportResult,
} from '@services/api/reports/patients.api'
import type { ReportBucketType } from '@services/api/reports/finance.api'
import { useFinanceReportQuery } from '@hooks/reports/useFinanceReportQuery'

export type PatientValueRevenueReportData = PatientValueRevenueReportResult

export type UsePatientValueRevenueReportResult = {
  loading: boolean
  error: string | null
  data: PatientValueRevenueReportData | null
  bucketLabel: string
}

export function usePatientValueRevenueReport(
  toolbarSelection: Record<string, string>,
): UsePatientValueRevenueReportResult {
  const getBucketFromData = useCallback(
    (data: PatientValueRevenueReportResult): ReportBucketType =>
      data.productionByProcedureMix.bucket,
    [],
  )

  return useFinanceReportQuery({
    toolbarSelection,
    fetchReport: getPatientValueRevenueReport,
    getBucketFromData,
    errorMessage: 'Failed to load patient value and revenue data',
  })
}
